export const storefrontFallbacks: Record<string, Record<string, string>> = {
  fr: {
    // ─── Header & Storefront Hero ─────────────────────────────────────────
    'FUKKONI LIVE STOREFRONT': 'BOUTIQUE EN LIGNE FUKKONI',
    'FUKKONI LITE': 'FUKKONI LITE',
    'FUKKONI PRO': 'FUKKONI PRO',
    'Verified Merchant': 'Commerçant vérifié',
    '✓ Verified Merchant': '✓ Commerçant vérifié',
    'Copy store link': 'Copier le lien de la boutique',
    'Show QR Code': 'Afficher le Code QR',
    'Share your store link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct orders.':
      'Partagez le lien de votre boutique sur votre bio Instagram, TikTok ou catalogue WhatsApp pour recevoir des commandes directes.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct online & delivery orders.':
      'Partagez le lien de votre établissement sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos commandes et livraisons.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct online & whatsapp orders.':
      'Partagez le lien de votre boutique sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos commandes en ligne et WhatsApp.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct appointments & bookings.':
      'Partagez le lien de votre établissement sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos rendez-vous et réservations.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct inquiries & viewing leads.':
      'Partagez le lien de votre agence sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos demandes de visites.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct rental reservations.':
      'Partagez votre lien sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos réservations de véhicules.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct room reservations.':
      'Partagez votre lien sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos réservations de chambres.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct orders & deliveries.':
      'Partagez le lien de votre boutique sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos commandes et livraisons.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct orders.':
      'Partagez le lien de votre boutique sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos commandes.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct bookings & session requests.':
      'Partagez votre lien sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos réservations de séances.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct client engagements & bookings.':
      'Partagez votre lien sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos demandes de prestations.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct fitting & custom orders.':
      'Partagez votre lien sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos commandes sur mesure.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct hardware orders.':
      'Partagez votre lien sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos commandes.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct ticket bookings.':
      'Partagez votre lien sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos réservations de billets.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct member registrations.':
      'Partagez votre lien sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos inscriptions.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct service bookings.':
      'Partagez votre lien sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos réservations.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct student enrollments.':
      'Partagez votre lien sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos inscriptions.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct laundry orders.':
      'Partagez votre lien sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos commandes de pressing.',
    'Share your business link on your Instagram bio, TikTok bio, or WhatsApp catalog to receive direct solar inquiries & orders.':
      'Partagez votre lien sur votre bio Instagram, profil TikTok ou catalogue WhatsApp pour recevoir directement vos demandes et commandes solaires.',
    'Open Store': 'Ouvrir la Boutique',
    'Visit': 'Visiter',
    'Visit Store': 'Visiter la Boutique',
    'Bio Link': 'Lien Bio',
    'Orders': 'Commandes',
    'Catalog': 'Catalogue',
    'Settings': 'Paramètres',
    'Live Items': 'Articles en Ligne',
    'Total Orders': 'Total Commandes',
    'Delivered': 'Livrées',
    'Completed': 'Terminé',
    'Overview': 'Aperçu',
    'Real-time statistics': 'Statistiques en temps réel',
    'Recent Orders': 'Commandes Récentes',
    'Store Activity': 'Activité de la Boutique',
    'Add Product': 'Ajouter un Produit',
    '+ Add Product': '+ Ajouter un Produit',
    'Post items with photos': 'Ajouter articles avec photos',
    'customer orders': 'commandes clients',
    'items in store': 'articles en boutique',
    'Logo & Delivery fee': 'Logo & Frais de Livraison',
    'Setup Checklist': 'Guide de Configuration',
    'Add Products to Catalog': 'Publier des produits au catalogue',
    'Post items with photos, prices & sizes': 'Ajouter photos, prix et tailles',
    'Paste Link on Social Media': 'Partager le lien sur les réseaux',
    'Add store link to Instagram & TikTok bio': 'Ajouter à la bio Instagram & TikTok',
    'Receive WhatsApp Orders': 'Recevoir des commandes WhatsApp',
    'Customers click & send orders directly': 'Les clients commandent directement',
    '+ Add': '+ Ajouter',
    'Copy': 'Copier',
    'View': 'Voir',
    'Back to Pro ERP': 'Retour à Pro ERP',
    'Catalog & Products': 'Catalogue & Produits',
    'Stock': 'Stock',
    'views': 'vues',
    'total orders received': 'commandes reçues au total',
    'New Orders': 'Nouvelles commandes',
    'Accepted': 'Acceptée',
    'In Transit': 'En cours de livraison',
    'No WhatsApp Orders Yet': 'Aucune commande WhatsApp pour le moment',
    'Storefront Settings': 'Paramètres de la Boutique',
    'Branding & Delivery': 'Image de marque & Livraison',
    'Save': 'Enregistrer',
    'Vacation mode': 'Mode vacances',
    'Your unique store web link on store.fukkoni.com': 'Le lien web unique de votre boutique sur store.fukkoni.com',
    'items': 'articles',
    'General': 'Général',
    'FUKKONI PRO ACTIVE': 'FUKKONI PRO ACTIF',
    'Your store account is upgraded to full FUKKONI Pro Point-of-Sale with multi-user permissions, thermal receipt printing, and enterprise accounting.':
      'Votre compte est passé à FUKKONI Pro complet avec caisse enregistreuse, permissions multi-utilisateurs, impression thermique et comptabilité entreprise.',
    'Open Pro POS Dashboard →': 'Ouvrir le Tableau de Bord Pro POS →',
    'Unsubscribe & Keep Lite': 'Résilier et Rester sur Lite',
    'Are you sure you want to unsubscribe from Pro? You will return to the Free Lite plan with bio link and social ordering.':
      'Êtes-vous sûr de vouloir résilier Pro ? Vous reviendrez au forfait gratuit Lite avec lien bio et commandes sociales.',
    'Yes, Downgrade to Lite': 'Oui, Rétrograder vers Lite',
    'FUKKONI PRO ACTIVE PLAN': 'FORFAIT ACTIF FUKKONI PRO',
    'Active Plan:': 'Forfait Actif :',
    'FUKKONI PRO ACTIVE — Full POS Cashier & Multi-Branch Access Enabled':
      'FUKKONI PRO ACTIF — Caisse Enregistreuse & Accès Multi-Succursales Activés',

    // ─── 3 Quick Steps Hero ───────────────────────────────────────────────
    'GETTING STARTED': 'POUR COMMENCER',
    '3 Quick Steps to Your First Sale:': '3 étapes rapides pour votre première vente :',
    '3 Quick Steps to Your First Client Booking:': '3 étapes rapides pour votre première réservation :',

    // Step 1 Titles
    'Post your products:': 'Publiez vos produits :',
    'Post your dishes & drinks:': 'Publiez vos plats & boissons :',
    'Post your services:': 'Publiez vos prestations :',
    'Post your properties:': 'Publiez vos biens immobiliers :',
    'Post your vehicles:': 'Publiez vos véhicules :',
    'Post your rooms & suites:': 'Publiez vos chambres & suites :',
    'Post your tickets & passes:': 'Publiez vos billets & pass :',
    'Post your clothing items:': 'Publiez vos articles de mode :',
    'Post your shoes:': 'Publiez vos chaussures :',
    'Post your tools & materials:': 'Publiez vos outils & matériaux :',
    'Post your packages:': 'Publiez vos formules & forfaits :',
    'Post your creations:': 'Publiez vos créations :',
    'Post your passes & classes:': 'Publiez vos pass & cours :',
    'Post your cleaning packages:': 'Publiez vos formules de nettoyage :',
    'Post your courses & trainings:': 'Publiez vos formations :',
    'Post your laundry services:': 'Publiez vos services de pressing :',
    'Post your solar equipment:': 'Publiez vos équipements solaires :',
    'Post your print products:': 'Publiez vos produits d\'impression :',

    // Step 1 Descriptions
    'Open your catalog and add items with pictures, prices, and sizes/colors.':
      'Ouvrez votre catalogue et ajoutez des articles avec photos, prix et tailles/couleurs.',
    'Open your catalog and add products with pictures, details, and pricing.':
      'Ouvrez votre catalogue et ajoutez des produits avec photos, prix et détails.',
    'Open your catalog and add dishes & drinks with pictures, details, and pricing.':
      'Ouvrez votre carte et ajoutez vos plats & boissons avec photos, détails et prix.',
    'Open your catalog and add services with pictures, details, and pricing.':
      'Ouvrez votre catalogue et ajoutez vos prestations avec photos, tarifs et description.',
    'Open your catalog and add properties with pictures, details, and pricing.':
      'Ouvrez votre catalogue et ajoutez vos biens avec photos, détails et prix.',
    'Open your catalog and add vehicles with pictures, details, and pricing.':
      'Ouvrez votre catalogue et ajoutez vos véhicules avec photos, caractéristiques et tarifs.',
    'Open your catalog and add rooms & suites with pictures, details, and pricing.':
      'Ouvrez votre catalogue et ajoutez des chambres & suites avec photos, détails et tarifs.',
    'Open your catalog and add tickets & passes with pictures, details, and pricing.':
      'Ouvrez votre catalogue et ajoutez des billets & pass avec dates, détails et tarifs.',
    'Open your catalog and add clothing items with pictures, details, and pricing.':
      'Ouvrez votre catalogue et ajoutez vos articles avec photos, tailles et prix.',
    'Open your catalog and add shoes with pictures, details, and pricing.':
      'Ouvrez votre catalogue et ajoutez vos chaussures avec photos, pointures et prix.',
    'Open your catalog and add tools & materials with pictures, details, and pricing.':
      'Ouvrez votre catalogue et ajoutez vos outils avec photos, spécifications et prix.',

    // Step 1 Action Buttons
    '+ Add Product Now': '+ Ajouter un produit maintenant',
    'Add Product Now': 'Ajouter un produit',
    '+ Add Dish Now': '+ Ajouter un plat maintenant',
    'Add Dish Now': 'Ajouter un plat',
    '+ Add Service Now': '+ Ajouter une prestation',
    'Add Service Now': 'Ajouter une prestation',
    '+ Add Property Now': '+ Ajouter un bien',
    'Add Property Now': 'Ajouter un bien',
    '+ Add Vehicle Now': '+ Ajouter un véhicule',
    'Add Vehicle Now': 'Ajouter un véhicule',
    '+ Add Room Now': '+ Ajouter une chambre',
    'Add Room Now': 'Ajouter une chambre',
    '+ Add Ticket Now': '+ Ajouter un billet',
    'Add Ticket Now': 'Ajouter un billet',
    '+ Add Item Now': '+ Ajouter un article',
    'Add Item Now': 'Ajouter un article',
    '+ Add Creation Now': '+ Ajouter une création',
    'Add Creation Now': 'Ajouter une création',

    // Step 2
    'Paste your link on Social Media:': 'Partagez votre lien sur les réseaux sociaux :',
    'to your instagram bio, tiktok profile, and whatsApp business status.':
      'à votre bio Instagram, profil TikTok et statut WhatsApp Business.',
    'Copy Link': 'Copier le lien',
    'Share WhatsApp': 'Partager sur WhatsApp',
    'QR Code': 'Code QR',

    // Step 3 Titles
    'Fulfill WhatsApp orders:': 'Traitez les commandes WhatsApp :',
    'Manage online & delivery orders:': 'Gérez vos commandes & livraisons :',
    'Manage online & whatsapp orders:': 'Gérez vos commandes en ligne & WhatsApp :',
    'Manage appointments & bookings:': 'Gérez vos rendez-vous & réservations :',
    'Manage inquiries & viewing leads:': 'Gérez vos demandes de visites & prospects :',
    'Manage rental reservations:': 'Gérez vos réservations de location :',
    'Manage room reservations:': 'Gérez vos réservations de chambres :',
    'Manage ticket bookings:': 'Gérez vos réservations de billets :',
    'Manage member registrations:': 'Gérez vos inscriptions de membres :',
    'Manage service bookings:': 'Gérez vos réservations de prestations :',
    'Manage student enrollments:': 'Gérez vos inscriptions d\'étudiants :',
    'Manage laundry orders:': 'Gérez vos commandes de pressing :',
    'Manage solar inquiries & orders:': 'Gérez vos demandes et commandes solaires :',
    'Manage hardware orders:': 'Gérez vos commandes de quincaillerie :',
    'Manage orders & deliveries:': 'Gérez vos commandes & livraisons :',

    // Step 3 Descriptions
    'When customers checkout, you receive instant orders ready to confirm and dispatch in 1 tap.':
      'Lorsque les clients commandent, vous recevez des commandes prêtes à confirmer et expédier en 1 clic.',
    'When customers reach out or checkout, you receive instant orders ready to confirm in 1 tap.':
      'Lorsque les clients passent commande ou vous contactent, vous recevez des alertes instantanées prêtes à être confirmées en 1 clic.',
    'When customers reach out or book, you receive instant requests ready to confirm in 1 tap.':
      'Lorsque les clients réservent, vous recevez des alertes instantanées prêtes à être confirmées en 1 clic.',

    // Step 3 Buttons
    'View Orders': 'Voir les commandes',
    'View Online & Delivery Orders': 'Voir les commandes & livraisons',
    'View Online & WhatsApp Orders': 'Voir les commandes en ligne & WhatsApp',
    'View Appointments & Bookings': 'Voir les rendez-vous & réservations',
    'View Inquiries & Viewing Leads': 'Voir les demandes de visites',
    'View Rental Reservations': 'Voir les réservations de location',
    'View Room Reservations': 'Voir les réservations de chambres',
    'View Ticket Bookings': 'Voir les réservations de billets',
    'View Member Registrations': 'Voir les inscriptions',
    'View Service Bookings': 'Voir les réservations',
    'View Student Enrollments': 'Voir les inscriptions',
    'View Laundry Orders': 'Voir les commandes de pressing',
    'View Solar Inquiries & Orders': 'Voir les demandes & commandes',
    'View Hardware Orders': 'Voir les commandes',
    'View Orders & Deliveries': 'Voir les commandes & livraisons',

    'Store is Active': 'Boutique active',
    'Store is Inactive': 'Boutique inactive',

    // ─── Metrics Cards ───────────────────────────────────────────────────
    'TODAY REVENUE': 'REVENUS DU JOUR',
    'Today Revenue': 'Revenus du Jour',
    'Pending Attention': 'À traiter',
    'Pending Fulfillment': 'En attente de traitement',
    'PENDING ATTENTION': 'À TRAITER',
    'TOTAL ONLINE ORDERS': 'TOTAL DES COMMANDES EN LIGNE',
    'PENDING FULFILLMENT': 'EN ATTENTE DE TRAITEMENT',
    'CATALOG SKUS': 'ARTICLES DU CATALOGUE',
    'Online Catalog': 'Catalogue en ligne',
    'Upgrade to Pro POS': 'Passer à FUKKONI Pro POS',
    'Upgrade to Pro': 'Passer à Pro',
    'Your Online Catalog is Empty': 'Votre catalogue en ligne est vide',
    'Add products with pictures, prices, and sizes/colors to display on your bio link store. Customers can click and order directly on WhatsApp!':
      'Ajoutez des produits avec photos, prix et variantes pour les afficher sur votre boutique bio link. Les clients peuvent commander directement sur WhatsApp !',
    '+ Add Your First Product': '+ Ajouter votre premier produit',
    'Add Your First Product': 'Ajouter votre premier produit',
    'When customers order from your bio link, their order details and WhatsApp alert will appear here in real-time.':
      'Lorsque les clients commandent depuis votre lien bio, leurs coordonnées et alertes WhatsApp apparaîtront ici en temps réel.',
    'Copy Bio Link to Share': 'Copier le lien bio à partager',
    'Apparel & Fashion Boutique': 'Boutique de Mode & Vêtements',
    'Apparel Catalog & Matrix': 'Catalogue & Grille des Tailles',
    'Boutique POS Cashier': 'Caisse Boutique POS',
    'Sales & Fitting Receipts': 'Ventes & Reçus d\'Essayage',
    'Garment Inventory & Stock': 'Stock & Vêtements',
    'Fitting Room Trials': 'Cabines d\'Essayage',
    'Tailor Alteration Tickets': 'Retouches & Coutures',
    'Fashion Brands & Suppliers': 'Marques & Fournisseurs',
    'VIP Clients & Stylist Bookings': 'Clients VIP & Rendez-vous Styliste',
    'Fashion Sales Analytics': 'Analyses Ventes de Mode',
    'Apparel Reports': 'Rapports Habillement',
    'Apparel Size-Color Matrix Grid': 'Grille Tailles-Couleurs',
    'Fitting Room & Trial Tracker': 'Suivi des Cabines d\'Essayage',
    'Apparel Retail Valuation': 'Valeur du Stock Vêtements',
    'Log Fitting Room Trial': 'Enregistrer un essayage',
    'Issue Tailor Ticket': 'Émettre un ticket retouche',
    'Add Garment Style': 'Ajouter un style',
    'BOUTIQUE & POS': 'BOUTIQUE & CAISSE',
    'APPAREL & STYLES': 'VÊTEMENTS & STYLES',
    'FITTING & ALTERATIONS': 'ESSAYAGES & RETOUCHES',
    'CLIENTS & STORE CREDIT': 'CLIENTS & CRÉDIT BOUTIQUE',

    // Category / Domain Labels
    'Menu & Dishes': 'Menu & Carte des Plats',
    'Dishes & Drinks': 'Plats & Boissons',
    'Online & Delivery Orders': 'Commandes & Livraisons',
    'Total Online & Delivery Orders': 'Total Commandes & Livraisons',
    'Total Online & WhatsApp Orders': 'Total Commandes en Ligne',
    'Total Appointments & Bookings': 'Total Rendez-vous & Réservations',
    'Total Orders & Deliveries': 'Total Commandes & Livraisons',
    'Recent Online & Delivery Orders': 'Commandes & Livraisons Récentes',
    'Recent Online & WhatsApp Orders': 'Commandes Récentes',
    'Recent Appointments & Bookings': 'Rendez-vous Récents',
    'Recent Inquiries & Viewing Leads': 'Demandes Récentes',
    'Recent Rental Reservations': 'Réservations Récentes',
    'All Online & Delivery Orders Manager': 'Gestionnaire des Commandes & Livraisons',
    'All Online & WhatsApp Orders Manager': 'Gestionnaire des Commandes en Ligne',
    'All Appointments & Bookings Manager': 'Gestionnaire des Rendez-vous',
    'No customer online & delivery orders yet': 'Aucune commande ou livraison reçue pour le moment',
    'No customer online & whatsapp orders yet': 'Aucune commande reçue pour le moment',
    'No customer appointments & bookings yet': 'Aucun rendez-vous pour le moment',
    'Search dishes & drinks...': 'Rechercher des plats & boissons...',
    '+ Add Dish': '+ Ajouter un plat',
    'Add Dish': 'Ajouter un plat',
    '+ Add Service': '+ Ajouter une prestation',
    'Add Service': 'Ajouter une prestation',
    '+ Add Property': '+ Ajouter un bien',
    'Add Property': 'Ajouter un bien',
    '+ Add Vehicle': '+ Ajouter un véhicule',
    'Add Vehicle': 'Ajouter un véhicule',
    'Add New Product': 'Ajouter un nouveau produit',
    'Dish Photos': 'Photos du plat',
    'Publish Dish': 'Publier le plat',
    'Publish New Dish': 'Publier un nouveau plat',
    'Configure Dish Details': 'Configurer les détails du plat',
    'Please enter dish name': 'Veuillez entrer le nom du plat',
    'Make your dish immediately available on your storefront link':
      'Rendez votre plat immédiatement disponible sur le lien de votre carte',
    'Add Dishes & Drinks to Menu & Dishes': 'Ajouter des plats & boissons au menu',
    'Add Products to Catalog & Products': 'Ajouter des produits au catalogue',
    'Post dishes & drinks with photos, prices & details': 'Ajoutez des plats & boissons avec photos, prix et détails',
    'Post products with photos, prices & details': 'Ajoutez des produits avec photos, prix et détails',
    'Receive Online & Delivery Orders': 'Recevoir des commandes & livraisons',
    'Receive Online & WhatsApp Orders': 'Recevoir des commandes WhatsApp',
    'Customers click & send requests directly': 'Les clients cliquent et envoient leurs demandes directement',
    'Footwear & Shoes': 'Chaussures & Maroquinerie',
    'Boutique & Fashion': 'Prêt-à-Porter & Boutique',
    'Hardware & Building': 'Quincaillerie & Matériaux',
    'Hotels & Lodging': 'Hôtels & Hébergement',
    'Ticketing & Events': 'Billetterie & Événements',
    'Fitness & Sports Club': 'Fitness & Club de Sport',
    'Cleaning & Maintenance': 'Nettoyage & Entretien',
    'Training & Courses': 'Formations & Cours',
    'Dry Cleaning & Laundry': 'Pressing & Blanchisserie',
    'Solar & Renewable Energy': 'Solaire & Énergie Renouvelable',
    'Printing & Custom Merch': 'Imprimerie & Personnalisation',
    'Clinics & Health': 'Clinique & Santé',
    'Catering & Events': 'Traiteur & Événements',
    'Auto & Spare Parts': 'Auto & Pièces Détachées',
    'Books & Stationery': 'Livres & Papeterie',
    'Art & Frames': 'Art, Toiles & Tableaux',
    'Eyewear & Optical': 'Lunettes & Optique',
    'Pet Supplies': 'Animaux & Accessoires',
    'Flowers & Gifts': 'Fleurs & Coffrets Cadeaux',
    'Gaming & Consoles': 'Jeux Vidéo & Consoles',
    'Music & Audio': 'Musique & Matériel Audio',
    'Pro Business': 'Entreprise Pro',
    'Store & Retail': 'Boutique & Commerce',
    'Hair Salon & Aesthetics': 'Salon de Coiffure & Esthétique',
    'Photography & Studio': 'Photographie & Studio',
    'Professional Services': 'Services Professionnels',
    'Tailoring & Couture': 'Couture & Vêtements sur Mesure',

    // ─── Pro Upgrade Card in Overview ────────────────────────────────────
    'GROW YOUR BUSINESS': 'DÉVELOPPEZ VOTRE ENTREPRISE',
    'Unlock Full FUKKONI Pro Point-of-Sale & Multi-User POS':
      'Débloquez la caisse enregistreuse FUKKONI Pro & le multi-utilisateur',
    'Take your store to the next level with physical store POS, barcode scanner, receipt printing, and team permissions.':
      'Passez au niveau supérieur avec le point de vente physique, le lecteur code-barres, l\'impression de reçus et les rôles d\'équipe.',
    'Activate FUKKONI Pro': 'Activer FUKKONI Pro',
    'In-Store POS Terminal': 'Terminal de Caisse en Magasin',
    'Fast touchscreen cashier for walk-in clients': 'Caisse tactile rapide pour les clients en magasin',
    'Advanced Analytics & Debt Tracking': 'Analyses Avancées & Suivi des Dettes',
    'Daily profit/loss, margin metrics & customer balances': 'Bénéfices/pertes journaliers, marges & soldes clients',
    'Multi-Branch & Cashier Roles': 'Multi-Succursales & Rôles Caissiers',
    'Add staff, manage permissions & shift reconciliation': 'Ajoutez des employés, gérez les permissions & les quarts',

    // ─── Catalog & Products Tab ──────────────────────────────────────────
    'SOCIAL COMMERCE CATALOG': 'CATALOGUE COMMERCE SOCIAL',
    'Online Catalog & Products': 'Catalogue en Ligne & Produits',
    'Manage your online store products, prices, size/color variants and live status.':
      'Gérez les produits de votre boutique en ligne, les prix, les variantes et le statut en direct.',
    'Manage products on your online store, prices, variants and live visibility.':
      'Gérez les produits de votre boutique en ligne, les prix, les variantes et le statut en direct.',
    'View Live Store': 'Voir la boutique en ligne',
    'View live store': 'Voir la boutique en ligne',
    'View Store': 'Voir la boutique',
    '+ Add New Product': '+ Ajouter un nouveau produit',
    '+ Add Online Product': '+ Ajouter un Produit en Ligne',
    'Add Online Product': 'Ajouter un Produit en Ligne',
    'Full Catalog': 'Catalogue Complet',
    'Search products by name...': 'Rechercher des produits par nom...',
    'Search online products...': 'Rechercher des produits en ligne...',
    'Published Online': 'Publiés en ligne',
    'Live on store': 'Publiés en ligne',
    'Actualiser': 'Actualiser',
    'Refresh': 'Actualiser',
    'All': 'Tous',
    'Live': 'En ligne',
    'Draft': 'Brouillon',
    'Drafts': 'Brouillons',
    'Product': 'Produit',
    'PRODUIT': 'PRODUIT',
    'Price': 'Prix',
    'PRIX': 'PRIX',
    'Status': 'Statut',
    'STATUT': 'STATUT',
    'Views': 'Vues',
    'VUES': 'VUES',
    'Actions': 'Actions',
    'ACTIONS': 'ACTIONS',
    'Live Online': 'En ligne',
    'En ligne': 'En ligne',
    'HOT': 'POPULAIRE',
    'Hot': 'Populaire',
    'hot': 'populaire',
    'DISCOUNT': 'PROMO',
    'Discount': 'Promo',
    'discount': 'promo',
    'NEW': 'NOUVEAU',
    'NEW ARRIVAL': 'NOUVEAUTÉ',
    'New Arrival': 'Nouveauté',
    'BEST SELLER': 'MEILLEURE VENTE',
    'Best Seller': 'Meilleure vente',
    'Select badge': 'Sélectionner un badge',
    'Edit': 'Modifier',
    'Modifier': 'Modifier',
    'Create 9:16 Social Story Graphic': 'Créer une story 9:16 pour les réseaux',
    'Copy Direct Product Link': 'Copier le lien direct du produit',
    'No products in catalog yet': 'Aucun produit dans le catalogue',
    'Click "+ Add New Product" above to create your first item with photos and variants.':
      'Cliquez sur "+ Ajouter un nouveau produit" ci-dessus pour créer votre premier article avec photos et variantes.',

    // ─── Orders Tab ──────────────────────────────────────────────────────
    'ORDER FULFILLMENT': 'TRAITEMENT DES COMMANDES',
    'Online & WhatsApp Orders': 'Commandes en Ligne & WhatsApp',
    'Real-time customer orders from your bio link storefront ready for WhatsApp confirmation and dispatch.':
      'Commandes clients en temps réel depuis votre boutique bio link, prêtes pour confirmation et expédition WhatsApp.',
    'Refresh Orders': 'Actualiser les commandes',
    'TOTAL DES COMMANDES': 'TOTAL DES COMMANDES',
    'TOTAL COMMANDES': 'TOTAL DES COMMANDES',
    'PENDING DISPATCH': 'EN ATTENTE D\'EXPÉDITION',
    'DELIVERED ORDERS': 'COMMANDES LIVRÉES',
    'Filtrer par statut': 'Filtrer par statut',
    'Filter by status': 'Filtrer par statut',
    'All Statuses': 'Tous les statuts',
    'Order #': 'N° Commande',
    'Customer & Address': 'Client & Adresse',
    'Items Ordered': 'Articles Commandés',
    'Total': 'Total',
    'Payment': 'Paiement',
    'Fulfillment Status': 'Statut de Traitement',
    'Action': 'Action',
    'New Order': 'Nouvelle Commande',
    'Processing': 'En Préparation',
    'Dispatched': 'Expédiée',
    'Cancelled': 'Annulée',
    'Cash on Delivery': 'Paiement à la livraison',
    'MoMo Pay': 'MoMo Pay',
    'Bank Transfer': 'Virement Bancaire',
    'WhatsApp': 'WhatsApp',
    'No orders received yet': 'Aucune commande reçue pour le moment',
    'Share your store link on social media to start receiving customer orders!':
      'Partagez le lien de votre boutique sur les réseaux sociaux pour commencer à recevoir des commandes !',

    // ─── Settings Tab ────────────────────────────────────────────────────
    'STORE CONFIGURATION': 'CONFIGURATION DE LA BOUTIQUE',
    'Storefront Settings & Branding': 'Paramètres de la Boutique & Image de Marque',
    'Customize your public store identity, bio description, WhatsApp ordering number, and delivery fees.':
      'Personnalisez l\'identité de votre boutique publique, la bio, le numéro de commande WhatsApp et les frais de livraison.',
    'Enregistrer les Modifications': 'Enregistrer les Modifications',
    'Save Changes': 'Enregistrer les Modifications',
    'Save Storefront Settings': 'Enregistrer les Paramètres',
    'Saving Changes...': 'Enregistrement en cours...',
    'Saving...': 'Enregistrement en cours...',
    'Storefront Link & Live Status': 'Lien de la Boutique & Statut en Ligne',
    'Control your public bio link visibility and test customer experience':
      'Contrôlez la visibilité de votre lien bio public et testez l\'expérience client',
    'YOUR BIO LINK': 'VOTRE LIEN BIO',
    'Store Online Status': 'Statut en Ligne de la Boutique',
    'Store is Online & Accepting Orders': 'La boutique est en ligne & accepte les commandes',
    'Store is Closed (Vacation Mode)': 'La boutique est fermée (Mode Vacances)',
    'Your store is currently public and accepting customer orders.':
      'Votre boutique est actuellement publique et accepte les commandes des clients.',
    'Your store is in vacation mode and closed for orders.':
      'Votre boutique est en mode vacances et fermée aux commandes.',
    'Your store is hidden from the public. Turn on to accept customer orders.':
      'Votre boutique est masquée au public. Activez pour accepter les commandes des clients.',
    'Online': 'En ligne',
    'Offline': 'Hors ligne',
    'Closed': 'Fermé',
    'Store Identity & Branding': 'Identité de la Boutique & Image de Marque',
    'Set how your business appears to shoppers': 'Définissez comment votre commerce apparaît aux acheteurs',
    'Store Display Name': 'Nom d\'affichage de la boutique',
    'Store Handle / URL Slug': 'Identifiant / Lien court de la boutique',
    'Store Bio & Tagline': 'Bio & Slogan de la boutique',
    'Store Logo': 'Logo de la boutique',
    'Store Cover Banner': 'Bannière de couverture',
    'Store Banner / Cover Photo': 'Bannière / Photo de couverture',
    'Upload Logo': 'Téléverser le Logo',
    'Upload Banner': 'Téléverser la Bannière',
    'Take Picture': 'Prendre une Photo',
    '✓ Photo Uploaded (File attached)': '✓ Photo Téléversée (Fichier joint)',
    '✓ Banner Uploaded (File attached)': '✓ Bannière Téléversée (Fichier joint)',
    'Or paste Logo URL (https://...)': 'Ou coller l\'URL du Logo (https://...)',
    'Or paste Banner URL (https://...)': 'Ou coller l\'URL de la Bannière (https://...)',
    'WhatsApp & Social Media': 'WhatsApp & Réseaux Sociaux',
    'WhatsApp Order Receiving Number': 'Numéro WhatsApp de réception des commandes',
    'Customers checkout alerts will be directed to this WhatsApp phone':
      'Les alertes de commande des clients seront envoyées à ce numéro WhatsApp',
    'Instagram Username': 'Nom d\'utilisateur Instagram',
    'TikTok Username': 'Nom d\'utilisateur TikTok',
    'Global Currency & Payment Methods': 'Devise Globale & Modes de Paiement',
    'Select Store Currency': 'Sélectionner la devise de la boutique',
    'Store Currency': 'Devise de la Boutique',
    'Currency Symbol Display': 'Affichage du Symbole de Devise',
    'Search world currency...': 'Rechercher une devise mondiale...',
    'Search currency by code, name, country...': 'Rechercher devise par code, nom, pays...',
    'Direct Online Payment Link (PayPal / Stripe / Revolut / CashApp)':
      'Lien de Paiement en Ligne Direct (PayPal / Stripe / Revolut / CashApp)',
    'If you have your own payment link (e.g. paypal.me/shop or buy.stripe.com/...), buyers can click to pay directly':
      'Si vous avez votre propre lien de paiement, les acheteurs peuvent cliquer pour payer directement',
    'Bank Transfer & Mobile Wallet Details': 'Coordonnées Bancaires & Portefeuilles Mobiles',
    'Bank / Provider Name': 'Nom de la Banque / Opérateur',
    'Account Number / IBAN': 'Numéro de Compte / IBAN',
    'Account Holder Name': 'Nom du Titulaire du Compte',
    'Mobile Money / USSD Code Instructions (Optional)': 'Instructions Code MoMo / USSD (Optionnel)',
    'Payment instructions, MoMo paycode, or USSD code shown at checkout':
      'Instructions de paiement, code marchand MoMo ou code USSD affichés à la commande',
    'e.g. *182*8*1*123456#, M-Pesa Till 582914': 'ex. *182*8*1*123456#, M-Pesa Till 582914',
    'Cash on Delivery / Pay on Pickup': 'Paiement à la livraison / au retrait',
    'Allow customers to place orders and pay when receiving items':
      'Permettre aux clients de commander et de payer à la réception',
    'Delivery Options': 'Options de Livraison',
    'Delivery Method': 'Méthode de Livraison',
    'Delivery Fee': 'Frais de Livraison',
    'Delivery & Shipping Fee': 'Frais de Livraison & Expédition',
    'Delivery Fee Type': 'Type de Frais de Livraison',
    'Free Delivery': 'Livraison Gratuite',
    'Flat Fee Delivery': 'Frais de Livraison Forfaitaire',
    'Flat Rate Delivery': 'Tarif Forfaitaire',
    'Plan & Subscription': 'Forfait & Abonnement',
    'Manage your FUKKONI subscription and plan tier': 'Gérez votre abonnement FUKKONI et votre formule',
    'Includes POS Cashier, thermal printing, multi-staff roles, and inventory tracking.':
      'Comprend la caisse enregistreuse POS, l\'impression thermique, les rôles multi-employés et le suivi des stocks.',
    'Includes unlimited catalog items, social bio link, WhatsApp ordering, and multi-currency.':
      'Comprend des articles de catalogue illimités, le lien bio, les commandes WhatsApp et le multi-devises.',
    'Unsubscribe from Pro?': 'Résilier l\'abonnement Pro ?',
    'You will downgrade to Free FUKKONI Lite and be logged out to refresh your session. Your online catalog, orders, and bio link will remain 100% active.':
      'Vous passerez à FUKKONI Lite Gratuit et serez déconnecté pour rafraîchir votre session. Votre catalogue, vos commandes et votre lien bio resteront 100% actifs.',
    'Yes, Unsubscribe & Logout': 'Oui, Résilier et Déconnecter',
    'Unsubscribe & Keep Free Lite': 'Résilier & Conserver Lite Gratuit',
    'Bio Link Store Online Status': 'Statut en Ligne de la Boutique Bio Link',
    'Public and accepting orders': 'Publique et accepte les commandes',
    'Temporarily offline / closed': 'Temporairement hors ligne / fermée',

    // ─── Add/Edit Product Modal ──────────────────────────────────────────
    'Publish New Online Product': 'Publier un Nouveau Produit en Ligne',
    'Configure Online Product Details': 'Configurer les Détails du Produit en Ligne',
    'Make your item immediately available on your storefront bio link':
      'Rendez votre article immédiatement disponible sur votre boutique bio link',
    'Product Name': 'Nom du produit',
    'Please enter product name': 'Veuillez entrer le nom du produit',
    'Please enter price': 'Veuillez entrer le prix',
    'Hide Price / Discuss on WhatsApp': 'Masquer le Prix / Discuter sur WhatsApp',
    'Show "Price on Request" & prompt customer to chat on WhatsApp to agree on price':
      'Afficher "Prix sur Demande" et inviter le client à discuter sur WhatsApp pour convenir du prix',
    'Online Sale Price': 'Prix de Vente en Ligne',
    'Online Sale Price ($)': 'Prix de Vente en Ligne',
    'Customer pays this': 'Le client paie ce montant',
    'Original Price (Optional)': 'Prix Original (Optionnel)',
    'Original Price (Optional) ($)': 'Prix Original (Optionnel)',
    'Struck-through price for -XX%': 'Prix barré pour -XX%',
    'Promotional Badge': 'Badge Promotionnel',
    'Select badge (Optional)': 'Sélectionner un badge (Optionnel)',
    'Product Photos': 'Photos du Produit',
    'Max 6 photos • 1st photo is Main Cover': 'Max 6 photos • La 1ère photo est la couverture principale',
    'Upload Photos (Multiple)': 'Téléverser des Photos (Multiples)',
    'Upload Photos': 'Téléverser des Photos',
    'Or paste image URL (https://...)': 'Ou coller l\'URL de l\'image (https://...)',
    'PRODUCT DESCRIPTION': 'DESCRIPTION DU PRODUIT',
    'Product Description': 'Description du Produit',
    'Describe item details, fabric, fit, ingredients, or warranty...':
      'Décrivez les détails de l\'article, matière, coupe, ingrédients, garantie...',
    'Describe your item, fit, fabric, material...':
      'Décrivez les détails de votre article, matière, coupe...',
    'e.g. Leather Oxford Shoes, Oversized Linen Shirt, Burger Combo...':
      'ex. Chaussures Oxford en cuir, Chemise en lin, Menu Burger...',
    'e.g. Trendy women fashion in Kigali': 'ex. Mode féminine tendance à Kigali',
    'e.g. Trendy women fashion, heels & accessories delivered to your door in Kigali.':
      'ex. Mode féminine tendance, talons & accessoires livrés à domicile à Kigali.',
    'Product Options & Variants': 'Options & Variantes du Produit',
    'Pick a business template or customize options (e.g. Size, Color, Flavor, Storage)':
      'Choisissez un modèle ou personnalisez vos options (ex. Taille, Couleur, Goût, Stockage)',
    'Business Templates': 'Modèles d\'Entreprise',
    'BUSINESS PRESETS': 'MODÈLES D\'ENTREPRISE',
    'BUSINESS PRESETS (21):': 'MODÈLES D\'ENTREPRISE (21):',
    '1-tap quick setup for any shop': 'Configuration rapide en 1 clic pour tout commerce',
    'Option Name': 'Nom de l\'Option',
    'Option Name:': 'Nom de l\'Option :',
    'Delete option group': 'Supprimer le groupe d\'options',
    '+ Add value (e.g. XL)': '+ Ajouter une valeur (ex. XL)',
    '+ Add Another Option (e.g. Material, Storage, Flavor)':
      '+ Ajouter une autre option (ex. Matière, Stockage, Goût)',
    'Publish Product': 'Publier le Produit',
    'Publishing...': 'Publication en cours...',
    'Cancel': 'Annuler',
    'Set Cover': 'Définir Couverture',
    'COVER': 'COUVERTURE',
    'Maximum 6 photos reached for this product.': 'Maximum 6 photos atteint pour ce produit.',
    'No variants added. Click below to add an option or pick a template above.':
      'Aucune variante ajoutée. Cliquez ci-dessous pour ajouter une option ou choisissez un modèle ci-dessus.',
    'Add': 'Ajouter',
    'Main cover photo updated': 'Photo de couverture principale mise à jour',
    'Image size should be under 10MB': 'La taille de l\'image doit être inférieure à 10 Mo',
    'Maximum 6 photos allowed per product': 'Maximum 6 photos autorisées par produit',

    // Business Presets
    '👗 Fashion / Clothing': '👗 Mode / Vêtements',
    '👟 Shoes & Footwear': '👟 Chaussures & Baskets',
    '🍔 Food / Restaurant': '🍔 Resto & Alimentation',
    '🍷 Wine & Drinks': '🍷 Vins & Boissons',
    '📱 Tech, Phones & PC': '📱 High-Tech & Téléphones',
    '💄 Cosmetics & Beauty': '💄 Cosmétiques & Beauté',
    '💊 Pharmacy & Health': '💊 Pharmacie & Santé',
    '💍 Jewelry & Watches': '💍 Bijoux & Montres',
    '🛋️ Home & Bedding': '🛋️ Maison & Déco',
    '👶 Baby & Kids': '👶 Bébés & Enfants',
    '🛒 Groceries & Supermarket': '🛒 Épicerie & Supermarché',
    '🏋️ Fitness & Gym Gear': '🏋️ Fitness & Sport',
    '🏢 Real Estate & Properties': '🏢 Immobilier & Propriétés',
    '🚗 Car Rental & Vehicles': '🚗 Location de Voitures & Véhicules',
    '🏨 Hotels, Lodges & Stays': '🏨 Hôtels & Séjours',
    '💇‍♀️ Salon, Spa & Wellness': '💇‍♀️ Salon de Coiffure & Spa',
    '💼 Services & Consulting': '💼 Prestations de Services & Conseil',
    '🧹 Cleaning & Maintenance': '🧹 Nettoyage & Entretien',
    '📸 Photography & Video': '📸 Photographie & Vidéo',
    '🌾 Agriculture & Farm Fresh': '🌾 Agriculture & Produits Fermiers',
    '☀️ Solar & Green Energy': '☀️ Solaire & Énergie Renouvelable',
    '🎓 Courses & Tutoring': '🎓 Formations & Cours Particuliers',
    '🖨️ Printing & Custom Merch': '🖨️ Imprimerie & Personnalisation',
    '🩺 Clinics & Medical Tests': '🩺 Clinique & Analyses Médicales',
    '🍱 Catering & Events': '🍱 Traiteur & Événements',
    '🚗 Auto & Spare Parts': '🚗 Auto & Pièces Détachées',
    '📚 Books & Stationery': '📚 Livres & Papeterie',
    '🎨 Art, Prints & Frames': '🎨 Art, Toiles & Tableaux',
    '🕶️ Eyewear & Sunglasses': '🕶️ Lunettes & Optique',
    '🐾 Pet Food & Supplies': '🐾 Animaux & Alimentation',
    '💐 Flowers & Gift Hampers': '💐 Fleurs & Coffrets Cadeaux',
    '🔨 Hardware & Tools': '🔨 Bricolage & Quincaillerie',
    '🎮 Gaming & Consoles': '🎮 Jeux Vidéo & Consoles',
    '🎟️ Event Tickets & Passes': '🎟️ Billetterie & Événements',
    '🧺 Laundry & Dry Cleaning': '🧺 Blanchisserie & Pressing',
    '🎸 Music & Audio Gear': '🎸 Musique & Matériel Audio',

    // Option Names & Values
    'Size': 'Taille',
    'Color': 'Couleur',
    'Shoe Size': 'Pointure',
    'Portion / Size': 'Portion / Taille',
    'Spice / Flavor': 'Épice / Goût',
    'Size / Volume': 'Taille / Volume',
    'Type / Blend': 'Type / Variété',
    'Storage / SSD': 'Stockage / SSD',
    'RAM Memory': 'Mémoire RAM',
    'Volume / Size': 'Volume / Contenance',
    'Shade / Skin Tone': 'Teinte / Carnation',
    'Dosage / Count': 'Dosage / Nombre',
    'Strength': 'Dosage',
    'Ring / Chain Size': 'Taille Bague / Chaîne',
    'Material / Karat': 'Matière / Carats',
    'Bed / Item Size': 'Taille Lit / Article',
    'Age / Size': 'Âge / Taille',
    'Weight / Pack Size': 'Poids / Format',
    'Weight / Resistance': 'Poids / Résistance',
    'Bag Size / Capacity': 'Taille / Capacité',
    'Frame / Lens Color': 'Monture / Couleur Verres',
    'Format / Language': 'Format / Langue',
    'Part Type / Fit': 'Type de Pièce / Modèle',
    'Edition / Platform': 'Édition / Plateforme',
    'Pet Size / Flavor': 'Taille Animal / Goût',
    'Medium / Size': 'Support / Format',
    'Tool Size / Spec': 'Taille / Spécification',
    'Ticket Tier / Date': 'Catégorie Billet / Date',
    'Property Type': 'Type de Propriété',
    'Bedrooms / Space': 'Chambres / Espace',
    'Listing Type': 'Type d\'Annonce',
    'Furnishing': 'Ameublement',
    'Vehicle Type': 'Type de Véhicule',
    'Transmission': 'Boîte de Vitesse',
    'Rental Duration': 'Durée de Location',
    'Driver Option': 'Option Chauffeur',
    'Room Type': 'Type de Chambre',
    'Bed Type': 'Type de Lit',
    'Board Plan': 'Formule Repas',
    'Service Type': 'Type de Prestation',
    'Stylist Level': 'Niveau du Coiffeur',
    'Consultation Tier': 'Formule de Consultation',
    'Meeting Format': 'Format de Rendez-vous',
    'Cleaning Package': 'Formule de Nettoyage',
    'Service Frequency': 'Fréquence de Service',
    'Session Type': 'Type de Séance',
    'Deliverables': 'Livrables',
    'Pack / Sack Size': 'Format Sac / Colis',
    'Quality / Grade': 'Qualité / Catégorie',
    'System Capacity': 'Puissance du Système',
    'Battery Type': 'Type de Batterie',
    'Course Level': 'Niveau du Cours',
    'Batch Quantity': 'Quantité d\'Impression',
    'Material / Finish': 'Matière / Finition',
    'Checkup Package': 'Bilan de Santé',
    'Service Mode': 'Lieu de Prélèvement',
    'Guest Count': 'Nombre d\'Invités',
    'Menu Tier': 'Formule Menu',
    'Turnaround Time': 'Délai de Livraison',
    'Gear / Instrument': 'Instrument / Matériel',
    'Package Bundle': 'Pack d\'Équipement',
    'Ticket Tier': 'Catégorie Billet',
    'Tool Spec / Size': 'Spécification Outil',
    'Power Type': 'Alimentation Électrique',
    'Frame Color': 'Couleur Monture',
    'Lens Type': 'Type de Verres',
    'Canvas / Print Size': 'Format Toile / Impression',
    'Framing / Finish': 'Encadrement / Finition',
    'Arrangement Size': 'Taille Composition',
    'Add-on Gift': 'Cadeau Complémentaire',
    'Auto-Configured Variant Attributes': 'Attributs et Variantes Auto-Configurés',
    'Fashion': 'Mode',
    'Real Estate': 'Immobilier',
    'Car Rental': 'Location Auto',
    'Shoes': 'Chaussures',
    'Food & Resto': 'Resto & Food',
    'Hotels': 'Hôtels',
    'Salon & Spa': 'Salon & Spa',
    'Services': 'Prestations',
    'Pharmacy': 'Pharmacie',
    'Tech': 'High-Tech',
    'Black': 'Noir',
    'White': 'Blanc',
    'Red': 'Rouge',
    'Blue': 'Bleu',
    'Green': 'Vert',
    'Brown': 'Marron',
    'Navy': 'Bleu Marine',
    'Space Grey': 'Gris Sidéral',
    'Silver': 'Argent',
    'Midnight': 'Minuit',
    'Gold': 'Or',
    'Regular': 'Standard',
    'Large': 'Grand',
    'Family Pack': 'Format Familial',
    'Mild': 'Doux',
    'Spicy': 'Épicé',
    'Extra Spicy': 'Très Épicé',
    'Red Wine': 'Vin Rouge',
    'White Wine': 'Vin Blanc',
    'Single Origin': 'Pure Origine',
    'Espresso': 'Espresso',
    '18k Gold': 'Or 18k',
    'Sterling Silver': 'Argent Sterling',
    'Rose Gold': 'Or Rose',
    'Platinum': 'Platine',
    'Single': 'Simple',
    'Double': 'Double',
    'Queen': 'Queen Size',
    'King': 'King Size',
    'Cotton': 'Coton',
    'Silk': 'Soie',
    'Linen': 'Lin',
    '0-6 Months': '0-6 Mois',
    '6-12 Months': '6-12 Mois',
    '1-2 Years': '1-2 Ans',
    '3-4 Years': '3-4 Ans',
    '500g': '500g',
    '1kg': '1kg',
    '2kg': '2kg',
    '5kg': '5kg',
    'Small': 'Petit',
    'Medium': 'Moyen',
    'Paperback': 'Broché',
    'Hardcover': 'Relié',
    'E-Book': 'E-Book',
    'Universal': 'Universel',
    'Front': 'Avant',
    'Rear': 'Arrière',
    'Standard Edition': 'Édition Standard',
    'Deluxe Edition': 'Édition Deluxe',
    'Collector\'s': 'Collector',
    'Chicken': 'Poulet',
    'Beef': 'Bœuf',
    'Fish': 'Poisson',
    'Original': 'Original',
    'Print (A3)': 'Impression (A3)',
    'Print (A2)': 'Impression (A2)',
    'Canvas': 'Toile',
    'Standard': 'Standard',
    'Heavy Duty': 'Usage Intensif',
    'General Admission': 'Entrée Générale',
    'VIP Access': 'Accès VIP',
    'VVIP Table': 'Table VVIP',
    'Early Bird': 'Prévente',

    // ─── Pro Upgrade Modal ───────────────────────────────────────────────
    'FUKKONI PRO UPGRADE': 'MISE À NIVEAU FUKKONI PRO',
    'Upgrade Store Account to FUKKONI Pro Point-of-Sale':
      'Passer le Compte Boutique à FUKKONI Pro Point de Vente',
    'CURRENT: FREE LITE': 'ACTUEL : LITE GRATUIT',
    'Catalog:': 'Catalogue :',
    'Products': 'Produits',
    'Store Link:': 'Lien de la Boutique :',
    'Business Category:': 'Catégorie d\'Activité :',
    'UPGRADING THIS ACCOUNT TO': 'PASSAGE DU COMPTE VERS',
    'ACTIVE MODULE': 'MODULE ACTIF',
    'FUKKONI PRO POS': 'FUKKONI PRO POS',
    'Select Enterprise Features to Activate:': 'Sélectionnez les Fonctionnalités Entreprise à Activer :',
    'POS Cashier Terminal & Barcode Scanning': 'Terminal de Caisse & Lecteur Code-Barres',
    'Fast checkout screen for physical stall/shop customers':
      'Écran de caisse rapide pour les clients en magasin physique',
    'Thermal Receipt & Invoice Printing': 'Impression Thermique Reçus & Factures',
    'Connect 58mm/80mm Bluetooth & USB receipt printers':
      'Connexion d\'imprimantes de reçus Bluetooth & USB 58mm/80mm',
    'Stock & Shelf Tracking': 'Suivi des Stocks & Rayons',
    'Track low-stock warnings, purchase orders, and wholesale batches':
      'Suivez les alertes de stock bas, commandes d\'achat et lots en gros',
    'Multi-Staff Roles & Cashier Permissions': 'Multi-Employés & Rôles Caissiers',
    'Create cashier/manager logins with shift cash reconciliation':
      'Créez des accès caissiers/responsables avec réconciliation de caisse',
    'Profit/Loss, Tax & Shift Reports': 'Rapports Profits/Pertes, Taxes & Quarts',
    'Full gross margins, revenue metrics, and expense tracking':
      'Marges brutes complètes, indicateurs de revenus et suivi des dépenses',
    'Zero Risk: Your online Lite store link and catalog stay 100% active and connected to your Pro account.':
      'Zéro Risque : Votre lien de boutique Lite et votre catalogue restent 100% actifs et connectés à votre compte Pro.',
    'Upgrade to FUKKONI Pro': 'Passer à FUKKONI Pro',
    'Upgrading...': 'Mise à niveau en cours...',
    'Notice: Upgrading will redirect you to log in to refresh your account permissions and initialize your new Pro POS features.':
      'Remarque : La mise à niveau vous redirigera vers la connexion pour actualiser vos permissions et initialiser vos fonctionnalités Pro POS.',
    'Shoes & Footwear': 'Magasin de Chaussures',
    'Shoe & Footwear Pro POS': 'Point de Vente Chaussures & Maroquinerie Pro',
    'Pharmacy Pro POS': 'Point de Vente Pharmacie Pro',
    'Bar & Lounge Pro POS': 'Point de Vente Bar & Lounge Pro',
    'Restaurant Pro POS': 'Point de Vente Restaurant Pro',
    'Hardware Pro POS': 'Point de Vente Quincaillerie Pro',
    'Fashion & Boutique POS': 'Point de Vente Prêt-à-Porter & Boutique',
    'Beauty & Cosmetics POS': 'Point de Vente Beauté & Cosmétiques',
    'Electronics & Tech POS': 'Point de Vente Électronique & Tech',
    'Jewelry & Accessories POS': 'Point de Vente Bijouterie & Accessoires',
    'Grocery & Supermarket POS': 'Point de Vente Épicerie & Supermarché',
    'Universal Retail & Services POS': 'Point de Vente Commerce de Détail & Services Universel',

    // ─── Story & QR Modal ────────────────────────────────────────────────
    '9:16 Social Story Graphic Generator': 'Générateur de Story 9:16 pour Réseaux Sociaux',
    'Share Product Story': 'Partager la Story du Produit',
    'Download Story Graphic': 'Télécharger le Visuel Story',
    'Share on WhatsApp Story': 'Partager sur WhatsApp Story',
    'Share on Instagram': 'Partager sur Instagram',
    'Store QR Code': 'Code QR de la Boutique',
    'Download QR Code': 'Télécharger le Code QR',
    'Print QR Flyer': 'Imprimer le Flyer QR',
    'Scan to order online directly from': 'Scannez pour commander en ligne directement chez',
    'Order Online:': 'Commander en Ligne :',
    'Scan to buy on WhatsApp': 'Scannez pour commander sur WhatsApp',
    'Copy Product Story Link': 'Copier le Lien Story du Produit',
    'Product link copied! You can screenshot or share this story card to Instagram / WhatsApp.':
      'Lien du produit copié ! Vous pouvez faire une capture d\'écran ou partager cette story sur Instagram / WhatsApp.',

    // ─── Registration & Fast-Track Onboarding ─────────────────────────────
    'Get Started with FUKKONI': 'Commencer avec FUKKONI',
    'Free Online Store (Lite)': 'Boutique en Ligne Gratuite (Lite)',
    'Enterprise POS (Pro)': 'Caisse POS Entreprise (Pro)',
    'Online Store': 'Boutique en Ligne',
    'Free · Setup in 1 min': 'Gratuit · En 1 minute',
    'Enterprise POS': 'Caisse & POS',
    'POS, Stock & Team': 'Caisse, Stock & Équipe',
    'Store / Brand Name': 'Nom de la Boutique / Marque',
    'e.g. Keza Boutique': 'ex. Boutique Keza',
    'Your Full Name': 'Votre Nom Complet',
    'e.g. Alice Keza': 'ex. Alice Keza',
    'WhatsApp Phone': 'Téléphone WhatsApp',
    'Select your business type': 'Sélectionnez votre type d\'activité',
    'Fashion & Boutique': 'Prêt-à-Porter & Boutique',
    'Wine, Coffee & Drinks': 'Vins, Café & Boissons',
    'Beauty & Cosmetics': 'Beauté & Cosmétiques',
    'Electronics & Tech': 'High-Tech & Électronique',
    'Jewelry & Accessories': 'Bijoux & Accessoires',
    'Grocery & Fresh Food': 'Épicerie & Produits Frais',
    'Hardware & Tools': 'Bricolage & Quincaillerie',
    'General Retail': 'Commerce Général',
    'Create Password': 'Créer un Mot de Passe',
    'Launch My Online Store': 'Lancer Ma Boutique en Ligne',
    'Please enter your store name': 'Veuillez entrer le nom de votre boutique',
    'Direct Link': 'Lien Direct',

    // ─── Pro POS Business Types & Categories ───────────────────────────────
    'Coffee & Drinks': 'Café & Boissons',
    'Retail & Boutique': 'Boutique & Commerce',
    'Retail & Commerce': 'Boutique & Commerce',
    'Pharmacy & Healthcare': 'Pharmacie & Santé',
    'Restaurant & Food': 'Restaurant & Alimentation',
    'Hospital & Clinic': 'Hôpital & Clinique',
    'Hospital': 'Hôpital',
    'Medical Clinic': 'Clinique Médicale',
    'Clinic': 'Clinique',
    'Hotel & Hospitality': 'Hôtel & Hébergement',
    'Bar & Lounge': 'Bar & Lounge',
    'Hardware & Materials': 'Quincaillerie & Matériaux',
    'Mobile Money & Services': 'Mobile Money & Services',
    'Hair Salon & Beauty': 'Salon de Coiffure & Beauté',
    'Barbershop & Grooming': 'Barbershop & Soins Homme',
    'Real Estate & Property': 'Immobilier & Propriétés',
    'Spa & Wellness': 'Spa & Bien-être',
    'Tailoring & Custom Clothing': 'Couture & Vêtements sur Mesure',
    'Car Rental & Vehicles': 'Location de Véhicules & Flotte',
    'Car Rental & Fleet': 'Location de Véhicules & Flotte',
    'Photography & Video': 'Photographie & Studio Média',
    'Photography & Media Studio': 'Photographie & Studio Média',
    'Professional Services & Consulting': 'Services Professionnels & Conseil',
    'High-Tech & Electronics': 'Électronique & High-Tech',
    'Grocery & Supermarket': 'Épicerie & Supermarché',

    // Direct French Presets Identity (Ensures translate("Café & Boissons") returns cleanly in FR)
    'Café & Boissons': 'Café & Boissons',
    'Boutique & Commerce': 'Boutique & Commerce',
    'Pharmacie & Santé': 'Pharmacie & Santé',
    'Restaurant & Alimentation': 'Restaurant & Alimentation',
    'Hôpital & Clinique': 'Hôpital & Clinique',
    'Hôtel & Hébergement': 'Hôtel & Hébergement',
    'Quincaillerie & Matériaux': 'Quincaillerie & Matériaux',
    'Magasin de Chaussures': 'Magasin de Chaussures',
    'Services Professionnels & Conseil': 'Services Professionnels & Conseil',

    // ─── Settings & Currency Management ────────────────────────────────────
    'Manage Currencies': 'Gérer les Devises',
    'Configure your primary base currency and multi-currency exchange settings.':
      'Configurez votre devise de base principale et les paramètres de change multidevises.',
    'Enable Global Currency Exchange': 'Activer le Change Multidevise Global',
    'When enabled, the system will allow manual configuration of exchange rates and show conversions in POS.':
      'Une fois activé, le système permet de configurer manuellement les taux de change et affiche les conversions dans la caisse POS.',
    'Base Currency (Default)': 'Devise de Base (Par Défaut)',
    'Base': 'Base',
    'Set as Default': 'Définir par défaut',
    'Set as Default Currency': 'Définir comme devise par défaut',
    'Primary Base Currency': 'Devise de Base Principale',
    'No currencies added yet': 'Aucune devise ajoutée pour le moment',
    'Click "+ Add Currency" above to enable your first shop currency.':
      'Cliquez sur "+ Ajouter une devise" ci-dessus pour activer votre première devise.',
    'Please select a currency': 'Veuillez sélectionner une devise',
    'Select currency': 'Sélectionner une devise',
    'Printer Settings': 'Paramètres d\'Impression',
    'Business Profile': 'Profil de l\'Entreprise',
    'Billing & Subscription': 'Facturation & Abonnement',
    'Online Storefront & Bio Link': 'Boutique en Ligne & Lien Bio',
    'Manage your application preferences, users, and roles.':
      'Gérez vos préférences d\'application, utilisateurs et rôles.',

    // ─── Super Admin Analytics & Geolocation ────────────────────────────────
    'Traffic & Visitor Origins': 'Trafic & Géolocalisation des Visiteurs',
    'Storefront Traffic & Real-Time Visitor Geolocation': 'Trafic des Boutiques & Géolocalisation des Visiteurs en Temps Réel',
    'Track exactly where customers are browsing from across DR Congo, Rwanda, East Africa, and global diaspora channels.':
      'Suivez précisément d\'où viennent vos visiteurs en RD Congo, au Rwanda, en Afrique de l\'Est et dans la diaspora mondiale.',
    'Refresh Traffic Data': 'Actualiser les Données de Trafic',
    'Total Storefront Visits': 'Total des Visites de Boutiques',
    'visits today': 'visites aujourd\'hui',
    'Top Visitor Origin': 'Première Provenance des Visiteurs',
    'of total traffic': 'du trafic total',
    'Mobile Traffic Share': 'Part de Trafic Mobile',
    'Smartphones & WhatsApp In-App Webviews': 'Smartphones & Navigateurs Intégrés WhatsApp',
    'Conversion Rate': 'Taux de Conversion',
    'orders placed': 'commandes passées',
    'Geographic Country Origins': 'Pays de Provenance des Visiteurs',
    'Top Active Cities': 'Villes les Plus Actives',
    'Traffic Acquisition Channels': 'Canaux d\'Acquisition & Sources de Trafic',
    'Store Traffic Leaderboard': 'Classement des Boutiques par Trafic',
    'Total Visitors': 'Total Visiteurs',
  },
};
